import { render, staticRenderFns } from "./EditLandingProduct.vue?vue&type=template&id=5736ccde&scoped=true"
import script from "./EditLandingProduct.vue?vue&type=script&lang=ts"
export * from "./EditLandingProduct.vue?vue&type=script&lang=ts"
import style0 from "./EditLandingProduct.vue?vue&type=style&index=0&id=5736ccde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5736ccde",
  null
  
)

export default component.exports